import React, {Fragment} from "react";
import Select, { Async } from "react-select";
import { Prompt } from "react-router-dom";
import moment from "moment";
import { RadioGroup, Radio } from "react-radio-group";
import Dialog from "../../../components/dialog";
import Overlay from "../../../components/overlay";
import {inspectionPrioritySelect,searchWHMachines} from "../../../backend/machines";

export default function() {
  const {
    loading,
    dialogVisible,
    uploading,
    machine_hours,
    machine_id,
    status,
    require_swap,
    priority,
    inspection_pass,
    inspection_note,
    one_way_swap,
    created_at,
    savedForm,
    machine,
    faulty_list,
    m_faulty_list,
  } = this.state;
  return (
    <div className="form">
      {loading && <Overlay />}
      <button className="prev_inspection" onClick={this._navigate(`/machine-history/${machine_id}`)}>
        Previous Inspections
      </button>

      {!savedForm && [
        <label className={savedForm ? "disabled" : ''}>Machine Number</label>,
        <Select
          value={{
            label: machine.code,
            value: machine.id
          }}
        />
      ]}

      <label className={savedForm ? "disabled" : ''}>Test and Tag</label>
      <input
        disabled
        type="date"
        value={moment(created_at).format("YYYY-MM-DD")}
      />

      <label className={savedForm ? "disabled" : ''}>Machine Status</label>
      <RadioGroup
        className={`radio-group ${savedForm ? "disabled" : ''}`}
        name={`machine-${machine_id}`}
        selectedValue={status}
        onChange={
            !savedForm ? this._editMachine(1, "radio", "status") : undefined
        }
        >
        <div>
            <Radio value={"Available"} /> <span>Passed</span>
        </div>
        <div>
            <Radio value={"Faulty"} /> <span>Issue</span>
        </div>
        <div>
            <Radio value={"Not Inspected"} /> <span>Not Inspected</span>
        </div>
        </RadioGroup>
        {( status === 'Faulty' || (savedForm && status === 'Faulty')) ? (
            <div>
            <label className={savedForm ? "disabled" : ''}>Equipment Fault</label>
            
            {!savedForm ? (
              <Fragment>
                <Select name={`faulty-${machine_id }`}
                  options={ !savedForm && m_faulty_list}
                  onChange={
                    !savedForm ? this._editMachine(1, "select", "faulty_reason") : undefined
                }></Select>

                {( (this.state.machine.faulty_reason !== undefined && this.state.machine.faulty_reason.other === 1) || (savedForm && this.state.machine.faulty_reason.other === 1)) && [
                  <label className={savedForm ? "disabled" : ''}>Please provide a brief description of the fault</label>,
                  <textarea
                  onChange={!savedForm ? this._editMachine(1, "input", "faulty_reason_text") : undefined}
                  />
                ]}
              </Fragment>
            ) : (
                <textarea className={savedForm ? "disabled" : ''} value={ faulty_list !== null && (JSON.parse(faulty_list)).text } />
            )}
          </div>
        ) : null}
      {/* <Select
        isDisabled={savedForm}
        value={{ value: status, label: status }}
        onChange={this._change("status", true, true)}
        options={machineStatusesSelect}
      /> */}

      <label className={savedForm ? "disabled" : ''}>Machine Hours</label>
      <input type="number"
        onChange={!savedForm ? this._change("machine_hours") : undefined} 
        value={ !savedForm ? machine_hours : this.state.machine.machine_hours  }
      />

      <label className={savedForm ? "disabled" : ''}>Inspection Passed</label>
      <RadioGroup
        className={`radio-group ${savedForm && "disabled"}`}
        name="inspection_pass"
        selectedValue={inspection_pass}
        onChange={!savedForm ? this._change("inspection_pass", true) : undefined }
      >
        <div>
          <Radio value={true} /> <span>Yes</span>
        </div>
        <div>
          <Radio value={false} /> <span>No</span>
        </div>
      </RadioGroup>

      <label className={savedForm ? "disabled" : ''}>Machine Swap</label>
      <RadioGroup
        className={`radio-group ${savedForm && "disabled"}`}
        name="require_swap"
        selectedValue={require_swap}
        onChange={!savedForm ? this._change("require_swap", true) : undefined }
      >
        <div>
          <Radio value={true} /> <span>Yes</span>
        </div>
        <div>
          <Radio value={false} /> <span>No</span>
        </div>
      </RadioGroup>

      {require_swap && [
        <label className={savedForm ? "disabled" : ''}>One Way Swap</label>,
        <RadioGroup
          className={`radio-group ${savedForm ? "disabled" : ''}`}
          name="one_way_swap"
          selectedValue={one_way_swap}
          onChange={!savedForm ? this._change("one_way_swap", true) : undefined}
        >
          <div>
            <Radio value={true} /> <span>Yes</span>
          </div>
          <div>
            <Radio value={false} /> <span>No</span>
          </div>
        </RadioGroup>
      ]}
      { (require_swap && !one_way_swap) && [
        <label className={savedForm ? "disabled" : ''}>New Machine Number</label>,
        <Async
          loadOptions={searchWHMachines}
          onChange={!savedForm ? this._change("new_machine_id", true, true) : undefined }
        />
      ]}
      <label className={savedForm ? "disabled" : ''}>Priority</label>
      <Select
        isDisabled={savedForm}
        value={{ value: priority, label: priority }}
        onChange={this._change("priority", true, true)}
        options={inspectionPrioritySelect}
      />

      <label className={savedForm ? "disabled" : ''}>Note</label>
      <textarea
        value={inspection_note !== null ? inspection_note : ''}
        onChange={!savedForm ? this._change("inspection_note") : undefined }
      />

      {!savedForm && (
        <button disabled={!this._valid()} onClick={this._toggleSubmitDialog}>
          Save
        </button>
      )}
      {dialogVisible && (
        <Dialog close={this._toggleSubmitDialog}>
          <div className="confirm-dialog">
            <h4>Ready to submit?</h4>
            <p></p>
            <button
              onClick={() => {
                this._upload();
                this._toggleSubmitDialog();
              }}
            >
              Confirm
            </button>
          </div>
        </Dialog>
      )}
      {uploading && <Dialog loader />}
      {[
        !savedForm && (
          <Prompt message="You are cancelling. Your progress will be lost." />
        )
      ]}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/machines/machine-form/view.js